/* eslint-disable react/jsx-sort-props */
import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import Text from '../../../common/Text'

import styles from './WhyNeat.module.scss'

export default function WhyNeat({ t }) {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <Text className={styles.label}>{t.label}</Text>
        <Text.H2 className={styles.title}>{t.title}</Text.H2>
        <Text.P className={styles.description}>{t.description}</Text.P>

        <div className={styles.grid}>
          {t.features.map((feature) => (
            <div key={feature.title} className={styles.card}>
              <div className={styles.iconWrap}>
                <div className={styles.blob}>
                  <Image
                    src={feature.blob}
                    alt=""
                    fill
                    style={{ objectFit: 'contain', marginTop: -4 }}
                  />
                </div>
                <div className={styles.icon}>
                  <Image
                    src={feature.icon}
                    alt={feature.title}
                    width={48}
                    height={48}
                    style={{ objectFit: 'contain' }}
                  />
                </div>
              </div>
              <Text.H3 className={styles.cardTitle}>{feature.title}</Text.H3>
              <Text.P className={styles.cardDesc}>{feature.description}</Text.P>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

WhyNeat.propTypes = {
  t: PropTypes.shape({
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    features: PropTypes.arrayOf(
      PropTypes.shape({
        blob: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
}
